// @flow
import { ICONS } from '../constants';

const getIcon = (name: string) => {
  let icon;

  switch (name) {
    case 'email':
      icon = ICONS.EMAIL;
      break;
    case 'instagram':
      icon = ICONS.INSTAGRAM;
      break;
    case 'facebook':
      icon = ICONS.FACEBOOK;
      break;
    case 'pinterest':
      icon = ICONS.PINTEREST;
      break;
    default:
      icon = {};
      break;
  }

  return icon;
};

export default getIcon;
